import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Image, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import validate from 'validate.js';
import { userLoginFetch, hideFeildValidationError, verifyToken } from "actions";
import { isEmpty } from 'lodash';
import MsalLogin from '../MsalLogin';
const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const session = useSelector(state => state.session);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      
    },
    touched: {
    },
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState(formState => ({
      ...formState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    if (session.error_type === 'validation') {
      const errors = session.error;
      setFormState(formState => ({
        ...formState,
        isValid: errors ? false : true,
        errors: errors || {}
      }));
    }
  }, [session.error_type, session.error]);

  //Need to check what this is doing, Syed Usman Hassan
  useEffect(() => {
    const redirect_url = new URLSearchParams(window.location.search).get('redirect_url');
    if (session.loggedIn && !isEmpty(localStorage.getItem("token")) && !isEmpty(session.user)) {
      //router.history.push('/');

      if (isEmpty(redirect_url)) {
        setTimeout(function () {
          window.location.replace("/");
        }, 500);
      }
      else {
        dispatch(verifyToken(localStorage.getItem("token"), redirect_url))

      }

    }
  }, [session.loggedIn, session.user, localStorage.getItem("token")]);

  const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
    dispatch(hideFeildValidationError(event.target.name));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    await dispatch(userLoginFetch(formState.values, navigate)); // Pass navigate to action
  };

  return (
    <>
      <div className="premier-logo text-center">
        <Image src="/assets/images/NX-logo.svg" />
      </div>
      <div className="login-form">
        <div className="text-center mb-4">
          <h1 className="font-24 fon-weight-s-bold">Login to get Started</h1>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="font-16 font-weight-medium">
              Email <span className="form-star-span">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              onChange={handleChange}
              value={formState.values.email || ''}
              placeholder="example@gmail.com"
              className={`h-48 border-radius-99 ps-4 font-13 font-weight-normal ${hasError('email') ? 'is-invalid' : ''}`}
            />
            <Form.Control.Feedback type="invalid">
              {hasError('email') ? formState.errors.email[0] : null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label className="font-16 font-weight-medium">
              Password <span className="form-star-span">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
              value={formState.values.password || ''}
              className={`h-48 border-radius-99 ps-4 font-13 font-weight-normal ${hasError('password') ? 'is-invalid' : ''}`}
            />
            <Form.Control.Feedback type="invalid">
              {hasError('password') ? formState.errors.password[0] : null}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <div className="d-flex align-items-center">
                <Form.Check type="checkbox" className="me-2" />
                <label className="font-14 font-weight-normal">Remember me</label>
              </div>
            </Form.Group>
            <Link to='/reset'>
              <a href="#" className="font-14 font-weight-medium">Forgot Password?</a>
            </Link>
          </div>

          <div className="login-btn">
            <Button type="submit" className="w-100 continue-btn h-48 border-radius-99 mb-3 border-0">Continue</Button>
            <MsalLogin />
          </div>
        </Form>
      </div>
    </>
  );
};

export default LoginForm;
